/**
 * Centralized branding tokens for white-label support.
 * All brand-specific text should reference these defaults.
 * Backend can override via DesignConfiguration.
 */
export const defaultBrandingTokens = {
  // Site Identity
  siteName: import.meta.env.VITE_SITE_NAME || 'EroChat',
  siteTitle: import.meta.env.VITE_SITE_TITLE || 'Erotic Chat Platform',
  metaDescription: import.meta.env.VITE_META_DESCRIPTION || 'Erlebe authentische, leidenschaftliche Unterhaltungen mit einzigartigen KI-Charakteren.',

  // Hero Section
  heroTitle: import.meta.env.VITE_HERO_TITLE || 'Intime Gespräche',
  heroSubtitle: import.meta.env.VITE_HERO_SUBTITLE || 'Erlebe authentische, leidenschaftliche Unterhaltungen mit einzigartigen KI-Charakteren.',

  // CTA Buttons
  primaryCTA: import.meta.env.VITE_PRIMARY_CTA || 'Jetzt heiss chatten',
  secondaryCTA: import.meta.env.VITE_SECONDARY_CTA || 'Kostenlos registrieren',

  // Theme
  themeName: import.meta.env.VITE_THEME_NAME || 'Purple Passion Premium',

  // Preset Author (for white-label)
  presetAuthor: import.meta.env.VITE_PRESET_AUTHOR || 'Design System Team',
} as const;

export type BrandingTokens = typeof defaultBrandingTokens;
